import {Route, Routes} from "react-router";
import AirBookingList from "./pages/list";
import AirBookingCreatePage from "./pages/create";
import AirBookingEditPage from "./pages/edit";
import AirBookingReportPage from "./pages/report";
import React from "react";
import TiedUpList from "./pages/tiedUpList";
import AnalyzeKrs from "./pages/analyzeKRS";

export default function () {
  return (

    <Routes>
      <Route path={"list"} exact={true} element={<AirBookingList/>}/>
      <Route path={"report"} exact={true} element={<AirBookingReportPage/>}/>
      <Route path={"create"} element={<AirBookingCreatePage/>}/>
      <Route path={"tiedUpTickets"} exact={true} element={<TiedUpList/>}/>
      <Route path={"edit/:id"} exact={true} element={<AirBookingEditPage/>}/>
      <Route path={"analyzeKrs"} exact={true} element={<AnalyzeKrs/>}/>
    </Routes>
  );
}
